(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["absen-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = new Set();

    const init = (root) => {
      if (!root || roots.has(root)) return;
      roots.add(root);

      const slides = Array.from(root.querySelectorAll('[data-absen-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-absen-dot]'));
      const videoLabels = Array.from(root.querySelectorAll('[data-absen-video-label]'));
      const progress = root.querySelector('[data-absen-progress]');
      const counter = root.querySelector('[data-absen-counter]');
      const progressbar = root.querySelector('[role="progressbar"]');
      const prev = root.querySelector('[data-absen-prev]');
      const next = root.querySelector('[data-absen-next]');
      const autoplay = root.dataset.autoplay === 'true';
      const delay = Number(root.dataset.delay) || 6000;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0;
      let timer;
      let paused = false;
      let pointerStart;

      const pauseVideos = (activeSlide) => {
        slides.forEach((slide) => {
          const video = slide.querySelector('video');
          if (!video) return;
          if (slide === activeSlide) {
            video.play().catch(() => {});
          } else {
            video.pause();
            video.currentTime = 0;
          }
        });
      };

      const render = (nextIndex) => {
        if (!slides.length) return;
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.tabIndex = active ? 0 : -1;
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
        videoLabels.forEach((label) => {
          label.hidden = Number(label.dataset.absenVideoLabel) !== index;
        });
        if (counter) counter.textContent = String(index + 1).padStart(2, '0');
        if (progress) progress.style.setProperty('--absen-progress', `${((index + 1) / slides.length) * 100}%`);
        if (progressbar) {
          progressbar.setAttribute('aria-valuenow', String(index + 1));
        }
        pauseVideos(slides[index]);
      };

      const stop = () => {
        window.clearTimeout(timer);
        timer = undefined;
      };

      const start = () => {
        stop();
        if (!autoplay || slides.length < 2 || paused || reduceMotion.matches || document.hidden) return;
        timer = window.setTimeout(() => {
          render(index + 1);
          start();
        }, delay);
      };

      const go = (nextIndex) => {
        render(nextIndex);
        start();
      };

      const onKeydown = (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          go(index + 1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          go(index - 1);
        } else if (event.key === 'Home') {
          event.preventDefault();
          go(0);
        } else if (event.key === 'End') {
          event.preventDefault();
          go(slides.length - 1);
        }
      };

      const onPointerDown = (event) => {
        pointerStart = event.clientX;
      };

      const onPointerUp = (event) => {
        if (pointerStart === undefined) return;
        const distance = event.clientX - pointerStart;
        pointerStart = undefined;
        if (Math.abs(distance) < 40) return;
        go(distance < 0 ? index + 1 : index - 1);
      };

      const onVisibility = () => {
        if (document.hidden) stop();
        else start();
      };

      const onMotionChange = () => start();

      const onMouseEnter = () => {
        paused = true;
        stop();
      };

      const onMouseLeave = () => {
        paused = false;
        start();
      };

      const onFocusIn = () => {
        paused = true;
        stop();
      };

      const onFocusOut = (event) => {
        if (root.contains(event.relatedTarget)) return;
        paused = false;
        start();
      };

      root.addEventListener('keydown', onKeydown);
      root.addEventListener('pointerdown', onPointerDown);
      root.addEventListener('pointerup', onPointerUp);
      root.addEventListener('mouseenter', onMouseEnter);
      root.addEventListener('mouseleave', onMouseLeave);
      root.addEventListener('focusin', onFocusIn);
      root.addEventListener('focusout', onFocusOut);
      document.addEventListener('visibilitychange', onVisibility);
      reduceMotion.addEventListener?.('change', onMotionChange);
      prev?.addEventListener('click', () => go(index - 1));
      next?.addEventListener('click', () => go(index + 1));
      dots.forEach((dot) => dot.addEventListener('click', () => go(Number(dot.dataset.absenDot))));

      render(0);
      start();
    };

    document.querySelectorAll('[data-absen-home-hero]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-absen-home-hero]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
